<template>
    <div>
        <nav aria-label="breadcrumb" class="crud-breadcrumb-nav">
            <ol class="breadcrumb crud-breadcrumb">
                <li class="breadcrumb-item" @click.prevent="mtdgotoprincipal()" style="cursor: pointer;">PRINCIPAL</li>
                <li v-if="!bcitens.item1.ativo" class="breadcrumb-item active">{{bcitens.item1.titulo}}</li>
                <li v-else class="breadcrumb-item"><a href="#" @click.prevent="mtdcancelarEdicao()">{{bcitens.item1.titulo}}</a></li>
                <li v-if="bcitens.item2.ativo" class="breadcrumb-item active">{{bcitens.item2.titulo}}</li>
            </ol>
        </nav>
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpbreadcrumb',
    props:['bcitens',
           'mtdcancelar'
          ],
    data: function() {
        return {};
    },
    methods: {
        mtdgotoprincipal() {
            util.gotoprincipal();
        },
        mtdcancelarEdicao() {
            if (typeof this.mtdcancelar === 'function') {
                this.mtdcancelar();
                return;
            }
            this.mtdgotoprincipal();
        }
    },
    computed:{

    },
    watch: {

    }
}
</script>
